import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Contract } from '../models/contract.model';
import { GLOBAL } from './global';
import { VariableService } from '../services/sharedVariables';

@Injectable()
export class ContractService{
   public url: string;
   public user_id: number;

   constructor(
     public _http: Http,
     public variableService:VariableService
   )
   {
     this.url = GLOBAL.url;
     this.user_id = parseInt(this.variableService.getCookie('user_id'));
   }

   getContracts()
   {
     return this._http.get(this.url+'contracts/'+this.user_id).map(res => res.json());
   }

   getContract(id:number)
   {
     return this._http.get(this.url+'contract/'+id+'/'+this.user_id).map(res => res.json());
   }
   getDebts()
   {
     return this._http.get(this.url+'ready-contracts-debt/'+this.user_id).map(res => res.json());
   }
   addContract(contract: Contract)
   {
     let json = JSON.stringify(contract);
     let params = 'json='+json;
     console.log(params);
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     return this._http.post(this.url+'add-contract/'+this.user_id,params, {headers:headers}).map(res => res.json());

   }

   updateContract(id:number,pContract: Contract)
   {
     let json = JSON.stringify(pContract);
     let params = "json="+json;
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     console.log(params);
     return this._http.post(this.url+'edit-contract/'+id+'/'+this.user_id,params,{headers: headers})
                       .map(res => res.json());
   }

   deleteContract(id:number)
   {
     return this._http.get(this.url+'delete-contract/'+id+'/'+this.user_id)
                     .map(res => res.json());
   }

   generateContract(service_id:number, id_contract:number,customer_id:number,report_name:string)
   {
     return this._http.get(this.url+'report-gen/customer/'+customer_id + '/contract/'+ id_contract +'/service/' + service_id+'/report_name/'+report_name+'/'+this.user_id).map(res => res.json());
   }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/services/contract.service.ts